import { GoogleOAuthProvider } from '@react-oauth/google';

import { AuthenticationModuleClientType } from '../../../../types';
import { GOOGLE_AUTH_CLIENT_ID } from '../../consts';

export const AuthProvider: AuthenticationModuleClientType['AuthProvider'] = ({ children }) => {
  return <GoogleOAuthProvider clientId={GOOGLE_AUTH_CLIENT_ID}>{children}</GoogleOAuthProvider>;
};
